import {Fragment, useEffect} from "react";
import {useForm, Controller, useFieldArray} from "react-hook-form";
import {yupResolver} from "@hookform/resolvers/yup";
import * as Yup from "yup";
import Button from "~/components/Button";
import Loading from "~/components/Loading";
import StatusLabel from "~/components/StatusLabel";
import {SelectField} from "~/components/Forms";
import {Col, Row} from "antd";
import {
	useCan
} from "~/hooks";

function WorkingDayFormTimeKeeping({item, time, onHandleSubmit}) {

	const canEditStatus = useCan('workingDayStatus');

	const options = [
		{value: 'workOnTime', label: <StatusLabel small type="green">Đúng giờ</StatusLabel>},
		{value: 'workOnline', label: <StatusLabel small type="blue">Làm online</StatusLabel>},
		{value: 'goLate', label: <StatusLabel small type="yellow">Đi làm trể</StatusLabel>},
		{value: 'goSoon', label: <StatusLabel small type="yellow">Về sớm</StatusLabel>},
		{value: 'halfDayOff', label: <StatusLabel small type="yellow">1/2 off 1/2 Công ty</StatusLabel>},
		//{value: 'halfDayOffNo', label: <StatusLabel small type="yellow">Nghỉ nữa buổi (Không phép)</StatusLabel>},
		{value: 'halfPaidHoliDays', label: <StatusLabel small type="yellow">1/2 off (Phép năm) 1/2 Công ty</StatusLabel>},
		// {value: 'halfDayOffHoliDayHalfWork', label: <StatusLabel small type="yellow">1/2 off (Phép năm) 1/2 Công ty</StatusLabel>},
		{value: 'halfOnlineHalfWork', label: <StatusLabel small type="blue">1/2 online 1/2 Công ty</StatusLabel>},
		{value: 'halfOnlineHalfOff', label: <StatusLabel small type="blue">1/2 online 1/2 off</StatusLabel>},
		// {value: 'halfOnlineHalfOffNo', label: <StatusLabel small type="blue">1/2 online 1/2 off (Không phép)</StatusLabel>},
		{value: 'halfOnlineHalfOffHoliDays', label: <StatusLabel small type="blue">1/2 online 1/2 off (Phép năm)</StatusLabel>},
		{value: 'dayOff', label: <StatusLabel small type="red">Nghỉ</StatusLabel>},
		// {value: 'dayOffNo', label: <StatusLabel small type="red">Nghỉ (Không phép)</StatusLabel>},
		{value: 'offPaidHoliDays', label: <StatusLabel small type="red">Nghỉ (Phép năm)</StatusLabel>},
		{value: 'halfDayOffHoliDayHalfDayOff', label: <StatusLabel small type="red">1/2 off (Phép năm) 1/2 off</StatusLabel>},
		{value: 'holiday', label: <StatusLabel small type="purple">Nghỉ lễ</StatusLabel>},
	]

	const weekday = ["Chủ Nhật","Thứ 2","Thứ 3","Thứ 4","Thứ 5","Thứ 6","Thứ 7"];

	const dateNow = new Date();

	const currentMonth = dateNow.getMonth() + 1;

	const date = (time) ? new Date(time*1000) : new Date();

	let month = date.getMonth() + 1;

	let year = date.getFullYear();

	let day = date.getDate();

	if(currentMonth != month) {
		const dateNew = new Date(year, month, 0);
		day = dateNew.getDate();
	}

	let listInput = [];

	month = (month < 10) ? '0'+month : month;

	for (let i = 1; i <= day; i++) {

		date.setDate(i)

		let iD = (i < 10) ? '0'+i : i;

		listInput.unshift({
			weekDayLabel : weekday[date.getDay()],
			weekDay : date.getDay(),
			time : `${iD}-${month}-${year}`,
			status: 'workOnTime'
		});
	}

	const initialValues = {
		timeKeeping: listInput,
	}

	const validationSchema = Yup.object().shape({})

	const {control, handleSubmit, formState: {isSubmitting, errors}, reset} = useForm({
		defaultValues: initialValues,
		resolver: yupResolver(validationSchema)
	});

	const {fields} = useFieldArray({
		control,
		name: "timeKeeping"
	});

	useEffect(() => {
		if(item?.id) {
			listInput.forEach((inputItem, index) => {
				if(item.detailsEdit[inputItem.time]) {
					listInput[index].status = item.detailsEdit[inputItem.time];
				}
			})
			initialValues.timeKeeping = listInput;
		}
		reset(initialValues);
	}, [item]);

	const onSubmit = async (data) => {
		await onHandleSubmit(data, item);
	}

	const WorkingDayItem = ({weekDay, control, index, status, errors}) => {
		return (
			<Fragment>
				{weekDay == 0 && <div className="form-group"><StatusLabel small type="red">Ngày nghỉ</StatusLabel></div>}
				{!canEditStatus && weekDay != 0 && options.find((item) => {return item.value === status})?.label}
				{(canEditStatus && weekDay != 0) &&
					<Controller control={control} name={`timeKeeping[${index}].status`} render={({ field }) => (
						<SelectField defaultValue={status} options={options} errors={errors} {...field} />
					)}/>
				}
			</Fragment>
		)
	}

	return (
		<form className="form" onSubmit={handleSubmit(onSubmit)}>
			{isSubmitting && <Loading/>}
			{fields.map(({weekDay, weekDayLabel, time, status}, index) => {
				return (
					<Row gutter={10} key={`${index}`}>
						<Col className="gutter-row" span={12}>
							<p><b>{`${weekDayLabel}`}</b></p>
							<p className="mb-1">{`${time}`}</p>
							{ (weekDay == 0) ? (<br />) : ''}
						</Col>
						<Col className="gutter-row" span={12}>
							<WorkingDayItem key={`${index}-${status}`} weekDay={weekDay} control={control} index={index} status={status} errors={errors} />
						</Col>
						{(weekDay == 1) ? <Col className="gutter-row" span={24}>< hr /></Col> : '' }
					</Row>
				);
			})}
			<hr />
			<div className="d-flex justify-content-end">
				{canEditStatus && <Button primary type="submit">Cập nhật</Button>}
			</div>
		</form>
	)
}

export default WorkingDayFormTimeKeeping;